import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const CreateContentLegacyQueryParamRedirect: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateContentLegacyQueryParamRedirect" */ '../src/CreateContentLegacyQueryParamRedirect.tsx'
			)
		).CreateContentLegacyQueryParamRedirect,
});
